module.exports = __webpack_public_path__ + "img/39.acf8a6d0.jpg";